/**
* DevExpress Dashboard (_scatter-point-label-options.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { pointLabelOptionsBaseSerializationsInfo, position } from '../../chart/metadata/_point-label-options';
export let content = {
    propertyName: 'content', modelName: '@Content', displayName: 'DashboardWebStringId.Chart.Content', defaultVal: 'Argument', simpleFormAdapterItem: 'listEditor', values: {
        'Argument': 'DashboardWebStringId.Binding.Argument',
        'Weight': 'DashboardWebStringId.Chart.Weight',
        'Values': 'DashboardWebStringId.Binding.Values',
        'ArgumentAndWeight': 'DashboardWebStringId.Chart.ArgumentAndWeight',
        'ArgumentAndValues': 'DashboardWebStringId.Chart.ArgumentAndValues'
    }
};
export let scatterPointLabelOptionsSerializationsInfo = pointLabelOptionsBaseSerializationsInfo.concat([content, position]);
